<div class="common-wrapper">
    <div class="main-hd-txt">
        <span>
            <h4>AGENDA PRIORITY<span class="head-btn-style">
                <button *ngIf="!listView" (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab">
                    <i class="bi bi-arrow-left-circle"></i> Back</button></span><span class="head-btn-style">
                    <button *ngIf="!listView" (click)="save($event)" class="save-btn-head" [disabled]="saveDisabled" title="Save">
                    <i class="bi bi-file-earmark-plus"></i> Save</button></span></h4>
        </span>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="agendaprioritys" [actionExclude]="['feedback','column']" [checkboxCol]="true"
            [entityColumns]="agendapriorityColumns" [selectionField]="'Agenda_Priority_Id'" [addEntityIcon]="'bi bi-plus-square'"
            [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'" (downloadEntities)="onExcelExport()"
            (addEntity)="addAgendaPriority($event)" (editEntity)="editAgendaPriority($event)"
            (refreshEntities)="refreshAgendaPriority($event)" (deleteEntity)="deleteAgendaPriority($event)"
            (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
            [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)"></grid>

    </div>

    <div *ngIf="!listView">  
        <div class="row sub-head"> 
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearAgendaPriority()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div> 
        </div>
        
        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Priority Name'" [mandatory]="true" [maxlength]="100" [formData]="entity"
                [fieldName]="'AgendaPriorityName'" [(ngModel)]="entity.AgendaPriorityName" ngDefaultControl></textbox>
         </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Description'" [mandatory]="false" [multiline]="true" [formData]="entity"
                            [maxlength]="500" [fieldName]="'Description'" [(ngModel)]="entity.Description"
                            ngDefaultControl>
                        </textbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <!-- <dropdown [caption]="'Venue Type'" [formData]="entity" [data]="basicmaster" [class] = "'form-control'"
                    [mandatory]="false" [filterable]="true" (filterChanged)="getAllVenue_type($event)"
                    [(ngModel)]="entity.OrderNo" [textField]="'DisplayText'" [valueField]="'DisplayValue'"
                    [fieldName]="'DisplayText'" [selectedItem]="selectedOrder" ngDefaultControl>
                </dropdown> -->
                    <textbox [caption]="'OrderNo'" [mandatory]="true" [maxlength]="2" [formData]="entity"
                            [fieldName]="'OrderNo'" (keypress)="numberOnly($event)" [(ngModel)]="entity.OrderNo"
                            ngDefaultControl></textbox>
                </div>
            </div>
         
            <div class="row">
                <div class="col-md-4 mb-2">
                    <checkbox [caption]="'Active'" [(ngModel)]="entity.IsActive"></checkbox>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-1">
                    <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'"
                        [type]="'button'" title="Back Tab"></btn>
                </div>
                <div class="col-md-4 mb-2">
                    <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'" [disabled]="saveDisabled"
                        [type]="'button'"></btn>
                </div>
            </div> -->
        </div>
        
    </div>
</div>

<ng-template #view let-dataItem let-rowIndex="rowIndex">
    <i class="bi bi-eye-fill" (click)="open(dataItem)"></i>
  </ng-template>
  <kendo-dialog title="Agenda Priority Details" *ngIf="opened" (close)="close()" [height]="500" [width]="1000">
    <div class="col-md-12 content-area">
        <div class="row">
        <div class="col-md-4 br-table-data">
            <label for="AgendaPriorityName" class="label label-1">Agenda Priority Name : </label> {{details.AgendaPriorityName }}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="Description" class="label label-1">Description : </label> {{details.Description }}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="OrderNo" class="label label-1">Order No : </label> {{details.OrderNo }}
          </div>
        </div>
        </div>
    </kendo-dialog>

<kendo-excelexport [data]="agendaprioritys.data" [collapsible]="true" fileName="AgendaPriority.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="Sl.No." [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="AgendaPriorityName" title="Priority" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="Description" title="Description" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="OrderNo" title="Order" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column> 
</kendo-excelexport>